import { render, staticRenderFns } from "./action_component.vue?vue&type=template&id=2748d974&"
import script from "./action_component.vue?vue&type=script&lang=js&"
export * from "./action_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports